import API from "@app/services/api";

/** The key the catalogue's drag and drop uses for « Sans classeur ». */
export const UNFILED = "none";

/**
 * A classeur of the reader's own for the catalogue's cohorts (PT-162). Personal, unlike a laboratory
 * classeur: filing a cohort arranges its reader's catalogue, never the cohort itself.
 */
export interface CohortFolder {
  id: string;
  name: string;
  specialite: string | null;
  /** False under « Vue médecin »: the previewed doctor's classeurs are read only. */
  can_write: boolean;
}

export async function fetchCohortFolders(): Promise<CohortFolder[]> {
  const res = await API.get({ path: "/cohort-folder/" });
  if (!res.ok || !res.data) throw new Error(res.error);
  return res.data.folders as CohortFolder[];
}

export async function createCohortFolder(name: string): Promise<CohortFolder> {
  const res = await API.post({ path: "/cohort-folder/", body: { name } });
  if (!res.ok || !res.data) throw new Error(res.error);
  return res.data as CohortFolder;
}

export async function renameCohortFolder(
  id: string,
  name: string,
): Promise<void> {
  const res = await API.put({ path: `/cohort-folder/${id}`, body: { name } });
  if (!res.ok) throw new Error(res.error);
}

export async function deleteCohortFolder(id: string): Promise<void> {
  const res = await API.delete({ path: `/cohort-folder/${id}` });
  if (!res.ok) throw new Error(res.error);
}

/** Files a cohort in one of the reader's classeurs, or takes it out with `null`. */
export async function fileCohort(
  cohortId: string,
  folderId: string | null,
): Promise<void> {
  const res = await API.put({
    path: `/cohort-folder/cohort/${cohortId}`,
    body: { folder_id: folderId },
  });
  if (!res.ok) throw new Error(res.error);
}
